import React from "react";

interface BaseIconProps {
  isActive?: boolean;
  className?: string;
}

export default function OpacityButton({ isActive, className }: BaseIconProps) {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="opacity-btn"
    >
      <g clip-path="url(#clip0_4862_1439)">
        <path
          opacity="0.25"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0.245117H7.2V7.44512H0V0.245117ZM14.4 7.44512H7.2V14.6451H0V21.8451H7.2V29.0451H0V36.2451H7.2V29.0451H14.4V36.2451H21.6V29.0451H28.8V36.2451H36V29.0451H28.8V21.8451H36V14.6451H28.8V7.44512H36V0.245117H28.8V7.44512H21.6V0.245117H14.4V7.44512ZM14.4 14.6451V7.44512H21.6V14.6451H14.4ZM14.4 21.8451H7.2V14.6451H14.4V21.8451ZM21.6 21.8451V14.6451H28.8V21.8451H21.6ZM21.6 21.8451H14.4V29.0451H21.6V21.8451Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_4862_1439">
          <rect y="0.245117" width="36" height="36" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
